import {
  portalBasicApi,
  portalBiApi,
  portalDataCollectionApi,
  earlyWarningApi,
  schedulerApi,
  earthLogApi
} from "../config/configApi";

import fetch from "../config/http";

export default {
  License: {
    CheckLicenseState: () => {
      return fetch(portalBasicApi + "/License/CheckLicenseState");
    }
  },
  Access: {
    ForgotPassword: params => {
      return fetch(portalBasicApi + "/Access/ForgotPassword", params, "POST");
    },
    ResetPassword: params => {
      return fetch(portalBasicApi + "/Access/ResetPassword", params, "POST");
    }
    // export const ResetPassword = params => http.post(PortalAPIUrl + "/Access/ResetPassword", params);
  },
  ClientMenu: {
    GetClientMenusByUserId: () => {
      return fetch(portalBasicApi + "/ClientMenu/GetClientMenusByUserId");
    },
    GetItemById: id => {
      return fetch(portalBasicApi + "/ClientMenu/GetItemById/" + id);
    }
  },

  /* 编码格式 */
  Encodingset: {
    // GetItems: (codingModule) => http.get(PortalAPIUrl + `/CodingRule/GetItems/?codingModule=${codingModule}`), //获得列表list
    // // CreateItem: (params) => http.post(PortalAPIUrl + "/CodingRule/CreateItem", params), 
    // GetItemRuleCode: (codingModule) => http.get(PortalAPIUrl + `/CodingRule/GetItemRuleCode?codingModule=${codingModule}`), //获得拼接好的编码
    // GenerateCode: (codingModule) => http.get(PortalAPIUrl + `/CodingRule/GenerateCode?CodingModule=${codingModule}`), //新建code编码

    CreateItem: params => {
      return fetch( //新增编码格式
        portalBasicApi + "/CodingRule/CreateItem",
        params,
        "POST"
      );
    },
    GetItems: codingModule => {
      return fetch(//获得列表list
        portalBasicApi + `/CodingRule/GetItems/?codingModule=${codingModule}`,
        {},
        "GET"
      );
    },

    GetItemRuleCode: codingModule => {
      return fetch( //获得拼接好的编码 
        portalBasicApi + `/CodingRule/GetItemRuleCode?codingModule=${codingModule}`,
        {},
        "GET"
      );
    },

    GenerateCode: codingModule => { //新建code编码
      return fetch(
        portalBasicApi + `/CodingRule/GenerateCode?CodingModule=${codingModule}`,
        {},
        "GET"
      );
    },


  },


  /* new推送任务 */
  Pushtask: {

    License: {
      CheckLicenseState: () => {
        return fetch(earlyWarningApi + "/License/CheckLicenseState");
      }
    },

    EmailTemplate: () => {
      return fetch(
        portalBasicApi + "/EmailTemplate/GetItems",
        {},
        "POST"
      );
    },


    GetEditInfoItemById: id => {
      return fetch(
        portalBasicApi + "/EmailTemplate/GetEditInfoItemById/" + id,
        {},
        "GET"
      );
    },

    GetQmcTaskList: () => {
      return fetch(
        earlyWarningApi + `/MessageTextSend/GetQmcTaskList?typeValue=0&currentPage=1&pageSize=200`,
        {},
        "GET"
      );
    },

    AddNewGroup: GroupName => {   // 添加组
      return fetch(
        earlyWarningApi + "/MessageTextSend/AddNewGroup?GroupName=" + GroupName,
        {},
        "GET"
      );
    },

    editNewGroup: params => {   // 编辑组
      return fetch(
        earlyWarningApi + "/MessageTextSend/EditNewGroup?GroupName=" + params.groupName + "&id=" + params.id,
        {},
        "GET"
      );
    },

    DelNewGroup: id => {   // 删除组
      return fetch(
        earlyWarningApi + "/MessageTextSend/DelNewGroup?id=" + id,
        {},
        "GET"
      );
    },

    DelListNewGroups: params => {   // 批量删除组
      return fetch(
        earlyWarningApi + "/MessageTextSend/DelListNewGroup",
        params,
        "POST"
      );
    },


    GetGroupList: (params) => {  //获取组列表
      return fetch(earlyWarningApi + "/MessageTextSend/GetGroupList", params, "POST")
    },


    GetNewItems: params => {  //获取列表
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetNewItems",
        params,
        "POST"
      )
    },

    GetNewItemByIds: id => {  //获取列表id
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetNewItemById?id=" + id,
        {},
        "GET"
      )
    },

    DeleteNewItemById: id => {  //修改成草稿或者删除
      return fetch(
        earlyWarningApi + "/MessageTextSend/DeleteNewItemById/" + id,
        {},
        "GET"
      )
    },

    CreateOrEditKpi: id => {  //发布
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditKpi?id=" + id,
        {},
        "GET"
      )
    },

    CopyNewItemByIds: id => {  //复制
      return fetch(
        earlyWarningApi + "/MessageTextSend/CopyNewItemById/" + id,
        {},
        "GET"
      )
    },


    GetParameters: id => {  //第四步 获取参数
      return fetch(
        earlyWarningApi + "/MessageTextSend/Get_Parameters/" + id,
        {},
        "GET"
      )
    },

    CreateOrEditKpi: params => { // 创建第一步 kpi
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditKpi",
        params,
        "POST"
      )
    },
    CreateOrEditQlikApp: params => { // 创建第二步
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditQlikApp",
        params,
        "POST"
      )
    },
    CreateOrEditPicture: params => { // 创建第三步 截图
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditPicture",
        params,
        "POST"
      )
    },
    CreateOrEditSendContent: params => { // 创建第四步 发送内容
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditSendContent",
        params,
        "POST"
      )
    },
    CreateOrEditSendUser: params => { // 创建第五步
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditSendUser",
        params,
        "POST"
      )
    },

    CreateOrEditDateQlikQmc: params => { // 创建第五步
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateOrEditDateQlikQmc",
        params,
        "POST"
      )
    },


    Getlogdata: params => { // 获取日志
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetTaskPushSendMessage",
        params,
        "POST"
      )
    },



    //  
  },
  //推送任务Qlik 

  PushQlikSense: {
    GetNewItemss: () => {
      return fetch(portalBasicApi + "/AppDesign/GetNewItems");
    },
    GetAppPublishList: () => {
      return fetch(portalBiApi + "/QlikSenseSocketJRPC/GetAppPublishList?productConfigID=2");
    },
    // //根据appId获取task触发器集合
    Getmeasure: id => {
      return fetch(
        portalBiApi + "/QlikSenseSocketJRPC/MeasureList?appId=" + id,
        {},
        "GET"
      );
    },

  },


  MessageTextSend: {
    GetMessageTextItems: params => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetItems",
        params,
        "POST"
      );
    },
    GetCreateInfo: () => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetCreateInfo",
        {},
        "POST"
      );
    },
    CreateItemClient: params => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/CreateItemClient",
        params,
        "POST"
      );
    },
    EditItemClient: params => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/EditItemClient",
        params,
        "POST"
      );
    },
    DeleteItemById: id => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/DeleteItemById/" + id,
        {},
        "GET"
      );
    },
    GetEditItemById: id => {
      return fetch(earlyWarningApi + "/MessageTextSend/GetEditItemById/" + id);
    },
    GetCreateInfoClient: () => {
      return fetch(
        earlyWarningApi + "/MessageTextSend/GetCreateInfoClient",
        {},
        "POST"
      );
    }
  },
  Job: {
    GetCreateInfo: params => {
      return fetch(schedulerApi + "/Job/GetCreateInfo", params, "POST");
    }
  },
  ParametersInfo: {
    GetParametersData: id => {
      return fetch(portalBasicApi + "/ParametersInfo/GetParametersData/" + id);
    }
  },
  AppDesign: {
    WidgetEditor: () => {
      return fetch(portalBasicApi + "/AppDesign/WidgetEditor");
    },
    MashupEditor: () => {
      return fetch(portalBasicApi + "/AppDesign/MashupEditor");
    },
    GetItems: params => {
      return fetch(portalBasicApi + "/AppDesign/GetItems", params, "POST");
    },
    CreateItem: params => {
      return fetch(portalBasicApi + "/AppDesign/CreateItem", params, "POST");
    },
    EditItem: params => {
      return fetch(portalBasicApi + "/AppDesign/EditItem", params, "POST");
    },
    GetItemById: id => {
      return fetch(portalBasicApi + "/AppDesign/GetItemById/" + id);
    },
    // //根据appId获取task触发器集合
    GetAppIdTaskTriggers: id => {
      return fetch(
        portalBiApi + "/QlikSenseQmc/GetAppIdTaskTriggers?appId=" + id,
        {},
        "POST"
      );
    },
    // //根据ID获取任务详情触发器Task 临时ID
    GetTaskEditTriggers: id => {
      return fetch(
        portalBiApi + "/QlikSenseQmc/GetTaskEditTriggers?id=" + id,
        {},
        "GET"
      );
    },
    // //根据ID获取任务详情触发器详情Task
    GetTaskEditTriggersDetail: params => {
      return fetch(
        portalBiApi +
        "/QlikSenseQmc/GetTaskEditTriggersDetail?id=" +
        params.id +
        "&type=" +
        params.type,
        {},
        "GET"
      );
    },
    // //根据ID修改任务详情Task
    UpdateTaskDetail: params => {
      return fetch(
        portalBiApi + "/QlikSenseQmc/UpdateTaskDetail",
        params,
        "POST"
      );
    },
    // // 创建任务 Task
    CreateTask: params => {
      return fetch(portalBiApi + "/QlikSenseQmc/CreateTask", params, "POST");
    },
    PublishApp: params => {
      return fetch(portalBasicApi + "/AppDesign/PublishApp", params, "POST");
    },
    Design: id => {
      return fetch(portalBasicApi + "/AppDesign/Design/" + id);
    },
    GetPublishApp: id => {
      return fetch(portalBasicApi + "/AppDesign/GetPublishApp/" + id);
    },
    DeleteItemById: (id, isDeleteBiQvf) => {
      return fetch(
        portalBasicApi + `/AppDesign/DeleteItemWithBiQvfById/${id}?isDeleteBiQvf=${isDeleteBiQvf}`,
        {},
        "GET"
      );
    },
    PreviewSheet: id => {
      return fetch(portalBasicApi + "/AppDesign/PreviewSheet?sheetId=" + id);
    },
    SyncSheet: () => {
      return fetch(portalBasicApi + "/AppDesign/SyncSheet");
    },
    GetCustomDataConfigInfo: id => {
      return fetch(portalBasicApi + "/AppDesign/GetCustomDataConfigInfo/" + id);
    },
    AddOrUpdateCustomDataConfig: params => {
      return fetch(
        portalBasicApi + "/AppDesign/AddOrUpdateCustomDataConfig",
        params,
        "POST"
      );
    },
    SyncCustomDataConfig: id => {
      return fetch(portalBasicApi + "/AppDesign/SyncCustomDataConfig/" + id);
    },
    GetAppTemplateQueryParameters: id => {
      return fetch(
        portalBasicApi + "/AppDesign/GetAppTemplateQueryParameters/" + id
      );
    },
    RefreshCustomData: params => {
      return fetch(
        portalBasicApi + "/AppDesign/RefreshCustomData",
        params,
        "POST"
      );
    },
    GetAppQueryParameters: appConfigId => {
      return fetch(
        portalBasicApi + "/AppDesign/GetAppQueryParameters/" + appConfigId
      );
    },
    TransferItem: params => {
      return fetch(
        portalBasicApi + "/AppDesign/TransferItem/",
        params,
        "POST"
      );
    },
    GetCopiesItems: params => {
      return fetch(
        portalBasicApi + "/AppDesign/GetCopiesItems/",
        params,
        "POST"
      );
    },
    PreviewDesign: id => {
      return fetch(portalBasicApi + "/AppDesign/PreviewDesign/" + id);
    },
    GetCopiesItemById: id => {
      return fetch(
        portalBasicApi + "/AppDesign/GetCopiesItemById/" + id
      );
    },
    DeleteCopies: params => {
      return fetch(
        portalBasicApi + "/AppDesign/DeleteCopies/",
        params,
        "POST"
      );
    },
    AddCopies: params => {
      return fetch(
        portalBasicApi + "/AppDesign/AddCopies/",
        params,
        "POST"
      );
    },
    EditCopies: params => {
      return fetch(
        portalBasicApi + "/AppDesign/EditCopies/",
        params,
        "POST"
      );
    },
    SetMainCopies: params => {
      return fetch(
        portalBasicApi + "/AppDesign/SetMainCopies/",
        params,
        "POST"
      );
    },
    GetAppSheetById: id => {
      return fetch(
        portalBasicApi + "/AppDesign/GetAppSheetById/" + id,
      );
    },
    SaveAppSheetOrderNumber: params => {
      return fetch(
        portalBasicApi + "/AppDesign/SaveAppSheetOrderNumber/",
        params,
        "POST"
      );
    },
    // 导出APP
    ExportApp: id => {
      return fetch(
        portalBasicApi + `/AppDesign/ExportApps/${id}`,
        {},
        "GET",
        false,
        true
      );
    },

    //撤销发布
    UnpublishApp: id => {
      return fetch(portalBasicApi + `/AppDesign/UnPublishAppItemById/${id}`);
    },

    //复制APP
    CopyApp: params => {
      return fetch(
        portalBasicApi + "/AppDesign/CopyItem",
        params,
        "POST"
      );
    },
    GetSenseAppWithSync: () => {
      return fetch(
        portalBasicApi + "/AppDesign/GetSenseAppWithSync"
      );
    },

    SenseAppSync: params => {
      return fetch(
        portalBasicApi + "/AppDesign/SenseAppSync",
        params,
        "POST"
      )
    },
    //获取APP分类
    GetAppClassification: id => {
      return fetch(portalBasicApi + `/AppGroup/GetItems/${id}`);
    },

    //新建分类
    AddClassification: params => {
      return fetch(
        portalBasicApi + '/AppGroup/CreateItem',
        params,
        "POST"
      )
    },

    //删除APP分类
    DelAppClassification: id => {
      return fetch(portalBasicApi + `/AppGroup/DeleteItemById/${id}`);
    },

    //编辑APP分类
    EditAppClassification: params => {
      return fetch(
        portalBasicApi + "/AppGroup/EditItem",
        params,
        "POST"
      );
    },

    //APP排序
    OrderByAPP: params => {
      return fetch(
        portalBasicApi + "/AppGroup/EditItemOrderBy",
        params,
        "POST"
      )
    },
    GetPushAppGroups: () => {
      return fetch(portalBasicApi + "/AppDesign/GetPushAppGroups");
    },
  },

  CustomDataSource: {
    GetCustomDataSourceList: () => {
      return fetch(
        portalBasicApi + "/CustomDataSource/GetCustomDataSourceList"
      );
    }
  },
  Roles: {
    GetItems: params => {
      return fetch(portalBasicApi + "/Roles/GetItems", params, "POST");
    },
    GetRoleByUser: () => {
      return fetch(portalBasicApi + "/Roles/GetRoleByUser");
    }
  },
  SystemConfig: {
    GetConfig: () => {
      return fetch(portalBasicApi + "/SystemConfig/GetConfig");
    },
    GetItem: () => {
      return fetch(portalBasicApi + "/SystemConfig/GetItem");
    }
  },
  ProductReportTree: {
    GetMyReport: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportTree/GetMyReport",
        params,
        "POST"
      );
    },
    GetMyKpi: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportTree/GetMyKpi",
        params,
        "POST"
      );
    },
    GetTree: () => {
      return fetch(portalBasicApi + "/Product/ProductReportTree/GetTree");
    },
    GetReportGroupBreadcrumb: (groupId) => {
      return fetch(
        portalBasicApi + "/Product/ProductReportTree/GetReportGroupBreadcrumb/" + groupId
      );
    },
    GetReport: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportTree/GetReport",
        params,
        "POST"
      );
    },
    GetMyShares: () => {
      return fetch(portalBasicApi + "/Product/ProductReportTree/GetMyShares");
    },
    GetAppConfigs: () => {
      return fetch(portalBasicApi + "/Product/ProductReportTree/GetAppConfigs");
    }
  },
  BIService: {
    GetBIProductJs: async id => {
      return fetch(
        portalBasicApi + "/BIServices/BIService/GetBIProductJs/" + id
      );
    },
    CloseReport: async sessionId => {
      return fetch(
        portalBasicApi + "/BIServices/BIService/CloseReport/" + sessionId
      );
    },
    GetBIReportMessage: (id, filter) => {
      return fetch(
        portalBasicApi + "/BIServices/BIService/GetBIReportMessage/" + id + (filter ? '/' + encodeURIComponent(filter) : '')
      );
    },
    GetAllPermissionProductReortsInfoByProductReportGroupId: params => {
      return fetch(
        portalBasicApi +
        "/BIServices/BIService/GetAllPermissionProductReortsInfoByProductReportGroupId/" +
        params.productReportId +
        "/" +
        params.isCollectionReport
      );
    },
    GetCurrentUserHavePermissionReportGroupTree: () => {
      return fetch(
        portalBasicApi +
        "/BIServices/BIService/GetCurrentUserHavePermissionReportGroupTree/all?domainName=" +
        window.location.hostname
      );
    },
    GetCollection: params => {
      return fetch(
        portalBasicApi + "/BIServices/BIService/GetCollection",
        params
      );
    },
    UpdateFile: params => {
      return fetch(portalBasicApi + "/BIServices/BIService/UpdateFile", params);
    },
    GetSheet: params => {
      return fetch(
        portalBasicApi + "/BIServices/BIService/GetSheet?AppConfigId=" + params
      );
    },
    GetAppConfigs: () => {
      return fetch(portalBasicApi + "/BIServices/BIService/GetAppConfigs");
    }
  },
  QlikSenseDataSource: {
    GetKpiTracks: params => {
      return fetch(
        portalBiApi +
        "/QlikSenseDataSource/GetKpiTracks?reportId=" +
        params.id +
        "&interval=" +
        params.interval,
        {},
        "POST"
      );
    },
    KpiMonitorManage: params => {
      return fetch(
        portalBiApi +
        "/QlikSenseDataSource/KpiMonitorManage?reportId=" +
        params.id,
        {}
      );
    }
  },

  // 评分
  UserReportScore: {
    GetItemById: id => {
      return fetch(
        portalBasicApi + "/UserReportScore/GetItemById?id=" + id,
        {},
        "POST"
      );
    },
    EditItem: params => {
      return fetch(
        portalBasicApi + "/UserReportScore/EditItem",
        params,
        "POST"
      );
    }
  },

  ProductReport: {
    EditProductUserOrderNumberItem: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/EditProductUserOrderNumberItem",
        params,
        "POST"
      );
    },
    RecommendReport: id => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/RecommendReport?id=" + id
      );
    },
    GetClientPushConfigById: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReport/GetClientPushConfigById?id=" +
        id
      );
    },

    AddClientPushConfig: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/AddClientPushConfig",
        params,
        "POST"
      );
    },

    EditClientPushConfig: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/EditClientPushConfig",
        params,
        "POST"
      );
    },

    GetClientReports: () => {
      return fetch(portalBasicApi + "/Product/ProductReport/GetClientReports");
    },
    GetClientPushConfigs: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/GetClientPushConfigs",
        params,
        "POST"
      );
    },

    GuessLike: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/GuessLike",
        params,
        "POST"
      );
    },
    FindReportByWord: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/FindReportByWord",
        params,
        "POST"
      );
    },
    GetReportInfoById: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/GetReportInfo",
        params
      );
    },
    GetUserFindLog: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReport/GetUserFindLog",
        params,
        "POST"
      );
    },
    DeleteClientPushConfig: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReport/DeleteClientPushConfig?id=" +
        id
      );
    },
    GetDataFilterByDictionaryId: params => {
      return fetch(
        portalBasicApi + "/DataFilter/GetDataFilterByDictionaryId/" + params.id
      );
    },
    GetPushReports: () => {
      return fetch(portalBasicApi + "/Product/ProductReport/GetPushReports");
    }
  },
  ProductReportComments: {
    DeleteComment: commentId => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/DeleteComment/" +
        commentId,
        {},
        "GET"
      );
    },
    GetCommentsByproductReportId: (params, ReportId) => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetCommentsByproductReportId/" +
        ReportId,
        params,
        "POST"
      );
    },
    UpdateLike: commentId => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/UpdateLike/" +
        commentId,
        {},
        "POST"
      );
    },
    CreateItem: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/CreateItem",
        params,
        "POST"
      );
    },
    CreateWeChatItem: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/CreateWeChatItem",
        params,
        "POST"
      );
    },

    GetMyCommentsPageList: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetMyCommentsPageList",
        params,
        "POST"
      );
    },
    GetCommentsOnMyPageList: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetCommentsOnMyPageList",
        params,
        "POST"
      );
    },
    GetCommentsAttentionMyPageList: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetCommentsAttentionMyPageList",
        params,
        "POST"
      );
    },
    ReplyComment: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/AddWriteBackComments",
        params,
        "POST"
      );
    },
    ZanComment: commentId => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/UpdateLike/" +
        commentId,
        {},
        "POST"
      );
    },
    GetHotComments: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetHotComments/" +
        params.productReportId +
        "/" +
        params.topNum,
        {},
        "POST"
      );
    },
    GetNewComments: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportCollection/ProductReportComments/GetTopComments", params,
        "POST"
      );
    }
  },
  ReportGroup: {
    GetProductReportNewLoadTimeCount: () => {
      return fetch(
        portalBasicApi +
        "/BIServices/ReportGroup/GetProductReportNewLoadTimeCount"
      );
    },
    GetCheckedReportList: params => {
      return fetch(
        portalBasicApi + "/BIServices/ReportGroup/GetMyBrowseProductReport",
        params,
        "POST"
      );
    },
    GetReport: params => {
      return fetch(
        portalBasicApi + "/BIServices/ReportGroup/GetReport",
        params,
        "POST"
      );
    },
    GetNewProductReport: params => {
      return fetch(
        portalBasicApi +
        "/BIServices/ReportGroup/GetProductReportPageByLoadTime",
        params,
        "POST"
      );
    },
    GetMyRecommendProductReportByUserId: params => {
      return fetch(
        portalBasicApi +
        "/BIServices/ReportGroup/GetMyRecommendProductReportByUserId",
        params,
        "POST"
      );
    },
    GetMyCollectProductReportByUserId: params => {
      return fetch(
        portalBasicApi +
        "/BIServices/ReportGroup/GetMyCollectProductReportByUserId",
        params,
        "POST"
      );
    },
    GetMyPublishProductReportByUserId: params => {
      return fetch(
        portalBasicApi +
        "/BIServices/ReportGroup/GetMyPublishProductReportByUserId",
        params,
        "POST"
      );
    }
  },
  PublicReport: {
    /**共享报表模块 */
    GetBIReportItems: params => {
      return fetch(
        portalBasicApi + "/PublicReport/GetBIReportItems",
        params,
        "POST"
      );
    }
  },
  ProductReportLabel: {
    CreateItem: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportLabel/CreateItem",
        params,
        "POST"
      );
    },
    GerReportLabel: id => {
      return fetch(
        portalBasicApi + "/Product/ProductReportLabel/GerReportLabel?id=" + id
      );
    }
  },
  TableauCustomView: {
    GetItems: reportId => {
      return fetch(portalBasicApi + "/TableauCustomView/GetItems/" + reportId);
    },
    CreateItem: params => {
      return fetch(
        portalBasicApi + "/TableauCustomView/CreateItem",
        params,
        "POST"
      );
    },
    DeleteItemById: reportId => {
      return fetch(
        portalBasicApi + "/TableauCustomView/DeleteItemById/" + reportId
      );
    },
    EditItem: params => {
      return fetch(
        portalBasicApi + "/TableauCustomView/EditItem",
        params,
        "POST"
      );
    }
  },
  OnlineData: {
    ProductUserHeartBeat: sessionId => {
      return fetch(
        portalBasicApi + "/OnlineData/ProductUserHeartBeat/" + sessionId
      );
    },
    UserHeartBeat: sessionId => {
      return fetch(portalBasicApi + "/OnlineData/UserHeartBeat/" + sessionId);
    }
  },
  UserGroup: {
    GetDepartmentTreeData: () => {
      return fetch(portalBasicApi + "/UserGroup/GetDepartmentTreeData");
    }
  },

  ReportShare: {
    GetItems: params => {
      return fetch(portalBasicApi + "/ReportShare/GetItems", params, "POST");
    },
    GetItemsNoPage: () => {
      return fetch(portalBasicApi + "/ReportShare/GetItemsNoPage", {}, "POST");
    },

    CreateItem: params => {
      return fetch(portalBasicApi + "/ReportShare/CreateItem", params, "POST");
    },
    GetAllShareUserId: id => {
      return fetch(
        portalBasicApi + "/ReportShare/GetAllShareUserId/" + id,
        {},
        "POST"
      );
    },
    DeleteItemById: id => {
      return fetch(
        portalBasicApi + "/ReportShare/DeleteItemById/" + id,
        {},
        "GET"
      );
    }
  },

  Users: {
    UpdateUserCustomSettingsCoverImg: params => {
      return fetch(
        portalBasicApi + "/Users/UpateUserCustomSettingsCoverImg",
        params,
        "POST",
        true
      );
    },
    GetItemSimpleByDepartMentId: id => {
      return fetch(portalBasicApi + "/Users/GetItemSimpleByDepartMentId/" + id);
    },
    GetCurrentUser: () => {
      return fetch(portalBasicApi + "/Users/GetCurrentUser");
    },
    EditCurrentUser: params => {
      return fetch(
        portalBasicApi + "/Users/EditCurrentUser",
        params,
        "POST",
        true
      );
    },
    GetUserCustomSettings: () => {
      return fetch(portalBasicApi + "/Users/GetUserCustomSettings");
    },
    UpdateUserCustomSettings: params => {
      return fetch(
        portalBasicApi + "/Users/UpateUserCustomSettings",
        params,
        "POST"
      );
    },
    GetItemByUserId: id => {
      return fetch(portalBasicApi + "/Users/GetItemByUserId/" + id);
    },
    EnableBarrage: status => {
      return fetch(portalBasicApi + "/Users/EnableBarrage?isEnable=" + status);
    },
    GetUserCreateInfo: () => {
      return fetch(portalBasicApi + "/Users/GetCreateInfo", {}, "POST");
    }
  },
  ProductReportLike: {
    Like: productReportId => {
      return fetch(
        portalBasicApi + "/ProductReportLike/Like/" + productReportId,
        {},
        "POST"
      );
    }
  },
  ProductReportFavorite: {
    CreateGroup: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/CreateItem",
        params,
        "POST"
      );
    },
    EditFavorite: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/EditItem",
        params,
        "POST"
      );
    },
    DeleteFavoriteFolder: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/DeleteItemById/" +
        id,
        {},
        "GET"
      );
    },
    DeleteFavorite: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/CancelFavorite/" +
        id,
        {},
        "GET"
      );
    },
    GetFavoriteFolderInfo: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/GetAllEditInfoItemById/" +
        id
      );
    },
    EditFavoriteFolderInfo: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/EditItemFolder",
        params,
        "POST"
      );
    },
    AddFavorite: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/AddMyFavoriteReport/" +
        params.ReportId +
        "/" +
        params.ProductReportGroupId,
        {},
        "POST"
      );
    },
    CancelFavorite: params => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/CancelFavoriteList",
        params,
        "POST"
      );
    },
    GetFavoriteUsersItemById: id => {
      return fetch(
        portalBasicApi +
        "/Product/ProductReportFavorite/ProductReportFavorite/GetFavoriteUsersItemById/" +
        id
      );
    }
  },
  Announcement: {
    GetAnnouncement: params => {
      return fetch(
        portalBasicApi + "/Announcement/GetAnnouncement",
        params,
        "POST"
      );
    },
    UpdateAnnouncementRead: id => {
      return fetch(
        portalBasicApi + "/Announcement/UpdateAnnouncementRead/" + id
      );
    },
    UpdateAnnouncementReadAll: query => {
      return fetch(
        portalBasicApi +
        "/Announcement/UpdateAnnouncementReadAll" +
        (query ? query : "")
      );
    },

    GetAnnouncementPopup: (module = 0) => {
      return fetch(
        portalBasicApi + "/Announcement/GetAnnouncementPopup?module=" + module
      );
    }
  },
  Message: {
    GetMessagePage: params => {
      return fetch(portalBasicApi + "/Message/GetMessagePage", params, "POST");
    },
    GetMessageCollection: () => {
      return fetch(portalBasicApi + "/Message/GetMessageCollection");
    },
    //Bom接口
    GetUserMenuPermissions: () => {
      return fetch(
        portalBasicApi + "/TranssionMenu/GetUserMenuPermissions",
        {},
        "POST"
      );
    },
    //Bom模拟接口
    GetBomRedirectUrl: () => {
      return fetch(
        portalBasicApi + "/BomRedirect/GetBomRedirectUri",
        {},
        "GET"
      );
    },
    //利润模拟接口
    GetProfitRedirectUri: language => {
      return fetch(
        portalBasicApi +
        "/BomRedirect/GetProfitRedirectUri?language=" +
        language,
        {},
        "GET"
      );
    }
  },
  UserLoginRedirectConfig: {
    GetItem: () => {
      return fetch(portalBasicApi + "/UserLoginRedirectConfig/GetItem");
    },
    SetItem: params => {
      return fetch(
        portalBasicApi + "/UserLoginRedirectConfig/SetItem",
        params,
        "POST"
      );
    },
    GetUserConfig: () => {
      return fetch(portalBasicApi + "/UserLoginRedirectConfig/GetUserConfig");
    }
  },
  DefaultReport: {
    GetDefaultReport: () => {
      return fetch(portalBasicApi + "/DefaultReport/GetDefaultReport");
    }
  },
  EbiReportDataSource: {
    GetSenseTableData: params => {
      return fetch(
        portalBasicApi + "/EbiReportDataSource/GetSenseTableData",
        params,
        "POST"
      );
    }
  },
  QlikSenseQmc: {
    EbiImportApps: params => {
      return fetch(
        portalBiApi + "/QlikSenseQmc/EbiImportApps",
        params,
        "POST",
        true
      );
    }
  },
  TodoTask: {
    //获取待办任务列表
    GetToDoTaskList: params => {
      return fetch(
        portalDataCollectionApi + "/TodoTask/GetItems?UserId=" + params.UserId,
        params.queryPageInfo,
        "POST"
      );
    },
    CheckTodoIsEdit: id => {
      return fetch(
        portalDataCollectionApi + "/TodoTask/CheckTodoIsEdit/" + id,
        {},
        "POST"
      );
    },
    SaveFormDataInCheckView: params => {
      return fetch(
        portalDataCollectionApi + "/TodoTask/EditReportItem",
        params,
        "POST"
      );
    },
    IsMultiTemplateSheet: id => {
      return fetch(portalDataCollectionApi + "/TodoTask/IsMultiTemplateSheet", {
        reporsId: id
      });
    },
    DeleteItemById: id => {
      return fetch(portalDataCollectionApi + "/TodoTask/DeleteItemById/" + id);
    },
    GetItemById: params => {
      return fetch(
        portalDataCollectionApi +
        "/TodoTask/GetItemById/" +
        params.id +
        "/" +
        params.templateType
      );
    },
    DownloadFileInTodoTask: id => {
      return fetch(
        portalDataCollectionApi + "/TodoTask/DownTemplateFile?templateId=" + id,
        {},
        "GET",
        false,
        true
      );
    },
  },
  TaskDone: {
    GetTaskDoneList: params => {
      return fetch(
        portalDataCollectionApi + "/TaskDone/GetItems?userId=" + params.userId,
        params.queryPageInfo,
        "POST"
      );
    },
    TaskIsRevoke: jobId => {
      return fetch(
        portalDataCollectionApi + "/TaskDone/CheckdoneTaskRevoke/" + jobId,
        {},
        "POST"
      );
    },
    CheckFile: params => {
      return fetch(portalDataCollectionApi + "/TaskDone/CheckFile", params);
    },
    DownloadFileInTaskDone: id => {
      return fetch(
        portalDataCollectionApi + "/TaskDone/DownFile?Id=" + id,
        {},
        "GET",
        false,
        true
      );
    }
  },
  DataManagement: {
    GetDataManagerExcelDataList: params => {
      return fetch(
        portalDataCollectionApi + "/Excel/GetDataManagerExcelDataList",
        params,
        "POST"
      );
    },
    DataManagerCheckBeforeApproval: params => {
      return fetch(
        portalDataCollectionApi + "/WorkFlow/DataManagerCheckBeforeApproval",
        params,
        "POST"
      );
    },
    DataManagerApproval: params => {
      return fetch(
        portalDataCollectionApi + "/WorkFlow/DataManagerApproval",
        params,
        "POST"
      );
    },
    ExecutionTemplateActions: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/ExecutionTemplateActions",
        params,
        "POST"
      );
    },
    GetDataManagerDatabaseDataList: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/GetDataManagerDatabaseDataList",
        params,
        "POST"
      );
    },
    SaveDataManagerDBData: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/SaveDataManagerDBData",
        params,
        "POST"
      );
    },
    DownLoadDataManagerDatabaseDataList: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/DownLoadDataManagerDatabaseDataList",
        params,
        "POST",
        false,
        true
      );
    }
  },
  FileUpload: {
    GetDirectoryContentByTemplateId: templateId => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/GetDirectoryContentByTemplateId?templateId=" + templateId,
        {},
        "GET"
      );
    },
    GetDirectoryContentByPath: path => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/GetDirectoryContentByPath?path=" + encodeURIComponent(path),
        {},
        "GET"
      );
    },
    FileExists: (filePath, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/FileExists?filePath=" + encodeURIComponent(filePath) + "&templateId=" + templateId,
        {},
        "GET"
      );
    },
    DeleteFile: (filePath, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/DeleteFile?filePath=" + encodeURIComponent(filePath) + "&templateId=" + templateId,
        {},
        "DELETE"
      );
    },
    DownloadFile: (filePath, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/DownloadFile?filePath=" + encodeURIComponent(filePath) + "&templateId=" + templateId,
        {},
        "GET",
        false,
        true
      );
    },
    UploadFile: (directoryPath, formData, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/UploadFile?directoryPath=" + encodeURIComponent(directoryPath) + "&templateId=" + templateId,
        formData,
        "POST",
        true // update=true 表示使用 FormData，不设置 Content-Type
      );
    },
    CreateDirectory: (directoryPath, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/CreateDirectory?directoryPath=" + encodeURIComponent(directoryPath) + "&templateId=" + templateId,
        {},
        "POST"
      );
    },
    DeleteDirectory: (directoryPath, templateId) => {
      return fetch(
        portalDataCollectionApi + "/FileUpload/DeleteDirectory?directoryPath=" + encodeURIComponent(directoryPath) + "&templateId=" + templateId,
        {},
        "DELETE"
      );
    }
  },
  InitiationWorkFlow: {
    GetInitiationWorkFlowList: params => {
      return fetch(
        portalDataCollectionApi +
        "/InitiationWorkFlow/GetItems?userId=" +
        params.userId,
        params.queryPageInfo,
        "POST"
      );
    },
    GetHasDataManagerMenu: params => {
      return fetch(
        portalDataCollectionApi +
        "/InitiationWorkFlow/GetHasDataManagerMenu",
        params,
        "GET"
      );
    },
    GetDataManagerTree: params => {
      return fetch(
        portalDataCollectionApi +
        "/InitiationWorkFlow/GetDataManagerTree",
        params,
        "GET"
      );
    },
  },
  TaskMonitor: {
    GetFlowInstanceProgress: id => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/GetFlowInstanceProgress/" + id
      );
    },
    GetTaskMonitorItemById: params => {
      return fetch(
        portalDataCollectionApi +
        "/TaskMonitor/GetItemById/" +
        params.id +
        "/" +
        params.templateType
      );
    },
    GetExcelDataListInTaskMonitor: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/GetExcelDataList",
        params,
        "POST"
      );
    },
    SaveReportExcelSheetData: params => {
      return fetch(
        portalDataCollectionApi + "/TaskMonitor/SaveReportExcelSheetData",
        params,
        "POST"
      );
    },
    GetVerifyFailureRecord: params => {
      return fetch(
        portalDataCollectionApi +
        "/TaskMonitor/GetVerifyFailureRecord",
        params,
        "POST"
      );
    },
    GetDictionaryDataFilterData: sheetID => {
      return fetch(
        portalDataCollectionApi +
        "/TaskMonitor/GetDictionaryDataFilterData/" +
        sheetID
      );
    },
    GetDictionaryDataFilterPageData: (dictionaryId, searchInfo, pageSize, pageIndex) => {
      if (searchInfo) {
        return fetch(
          portalDataCollectionApi +
          `/TaskMonitor/GetDictionaryDataFilterPageData?dictionaryId=${dictionaryId}&searchInfo=${searchInfo}&pageSize=${pageSize}&pageIndex=${pageIndex}`);
      } else {
        return fetch(
          portalDataCollectionApi +
          `/TaskMonitor/GetDictionaryDataFilterPageData?dictionaryId=${dictionaryId}&pageSize=${pageSize}&pageIndex=${pageIndex}`);
      }
    },
    GetMappingCalculate: sheetID => {
      return fetch(
        portalDataCollectionApi +
        "/TaskMonitor/GetMappingCalculate/" +
        sheetID
      );
    },

  },
  WorkFlow: {
    AuditSubmitInTodoTask: params => {
      return fetch(
        portalDataCollectionApi + "/WorkFlow/Approval",
        params,
        "POST"
      );
    },
    GetJobApprovalInfo: params => {
      return fetch(
        portalDataCollectionApi + "/WorkFlow/ApprovalInfo",
        params,
        "POST"
      );
    }
  },
  Report: {
    InitiationProcessCreateReport: params => {
      return fetch(
        portalDataCollectionApi +
        "/Report/InitiationProcessCreateReport/" +
        params.id +
        "/" +
        params.userId
      );
    }
  },
  Excel: {
    ImportDataInTodoTask: (params) => {
      return fetch(
        portalDataCollectionApi + "/Excel/Import",
        params,
        "POST",
        true,
      );
    },
    DownCsvOrTxtFileByStream: id => {
      return fetch(
        portalDataCollectionApi + "/Excel/DownCsvOrTxtFileByStream?id=" + id,
        {},
        "GET",
        false,
        true
      );
    },
    DownExcelFileByStream: id => {
      return fetch(
        portalDataCollectionApi + "/Excel/DownExcelFileByStream?id=" + id,
        {},
        "GET",
        false,
        true
      );
    },
    DataManagerImport: (params) => {
      return fetch(
        portalDataCollectionApi + "/Excel/DataManagerImport",
        params,
        "POST",
        true,
      );
    },
  },
  UserFans: {
    GetUserFansVisitorLog: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetUserFansVisitorLog",
        params,
        "POST"
      );
    },
    AddUserFansVisitorLog: id => {
      return fetch(portalBasicApi + "/UserFans/AddUserFansVisitorLog/" + id);
    },
    GetUserDynamicById: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetUserDynamicById",
        params,
        "POST"
      );
    },
    GetMyFansListPages: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetMyFansListPages",
        params,
        "POST"
      );
    },
    GetUserDetail: id => {
      return fetch(portalBasicApi + "/UserFans/GetUserDetail/" + id);
    },
    CheckUserAccess: id => {
      return fetch(portalBasicApi + "/UserFans/CheckUserAccess/" + id);
    },
    GetMyAddUserAsFansListPages: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetMyAddUserAsFansListPages",
        params,
        "POST"
      );
    },
    AddUserAsFans: params => {
      return fetch(portalBasicApi + "/UserFans/AddUserAsFans", params, "POST");
    },
    UpdateUserFansStatus: params => {
      return fetch(
        portalBasicApi + "/UserFans/UpdateUserFansStatus",
        params,
        "POST"
      );
    },
    DeleteItemById: id => {
      return fetch(
        portalBasicApi + "/UserFans/DeleteItemById/" + id,
        {},
        "GET"
      );
    },
    GetUserFansFans: id => {
      return fetch(portalBasicApi + "/UserFans/GetUserFansFans/" + id);
    },
    GetFansMessageListPages: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetFansMessageListPages",
        params,
        "POST"
      );
    },
    GetBlockUserList: params => {
      return fetch(
        portalBasicApi + "/UserFans/GetBlockUserList",
        params,
        "POST"
      );
    },
    AddBlockUser: params => {
      return fetch(portalBasicApi + "/UserFans/AddBlockUser", params, "POST");
    },
    DeleteBlockUser: params => {
      return fetch(
        portalBasicApi + "/UserFans/DeleteBlockUser",
        params,
        "POST"
      );
    }
  },
  Upload: {
    GetMaxChunkIndex: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/GetMaxChunkIndex",
        params
      );
    },
    MergeFiles: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/MergeFiles",
        params,
        "POST"
      );
    },
    GetItems: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/GetItems",
        params,
        "POST"
      );
    },
    GetUnChunkedItems: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/GetUnChunkedItems",
        params
      );
    },
    Delete: id => {
      return fetch(portalDataCollectionApi + "/Upload/Delete", { id: id });
    },
    DownLoadSucceedUpLoadedFile: id => {
      return fetch(
        portalDataCollectionApi +
        "/Upload/DownLoadSucceedUpLoadedFile?id=" +
        id,
        {},
        "GET",
        false,
        true
      );
    },
    PauseAll: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/PauseAll",
        params,
        "POST"
      );
    },
    DeleteInUpLoadList: params => {
      return fetch(
        portalDataCollectionApi + "/Upload/DeleteinUpLoadList",
        params
      );
    }
  },
  CardDownload: {
    DownLoadEdgeExtension: () => {
      return fetch(portalBasicApi + "/CardDownload/DownLoadEdgeExtension");
    },
    DownLoadChromeExtension: () => {

      const { protocol, hostname, port } = window.location;

      const currentPort = port ? ":" + port : "";

      const url = protocol + "//" + hostname + currentPort

      return fetch(
        portalBasicApi + "/CardDownload/DownLoadChromeExtension?hostName=" + url,
        {},
        "GET",
        false,
        true
      );
    }
  },
  CustomHome: {
    GetFavReport: params => {
      return fetch(portalBasicApi + "/CustomHome/GetFavReport", params);
    }, // 我的收藏
    GetReportViewLog: params => {
      return fetch(portalBasicApi + "/CustomHome/GetReportViewLog", params);
    }, // 我看过的
    GetAnnouncementInfo: params => {
      return fetch(portalBasicApi + "/CustomHome/GetAnnouncementInfo", params);
    }, // 公告消息
    GetMessageInfo: params => {
      return fetch(portalBasicApi + "/CustomHome/GetMessageInfo", params);
    }, // 系统消息
    GetFansMessageListPages: params => {
      return fetch(
        portalBasicApi + "/CustomHome/GetFansMessageListPages",
        params
      );
    }, // 我的消息
    GetUserFansVisitorLog: params => {
      return fetch(
        portalBasicApi + "/CustomHome/GetUserFansVisitorLog",
        params,
        "POST"
      );
    }, // 我的访客
    GetTopComments: params => {
      return fetch(
        portalBasicApi + "/CustomHome/GetTopComments",
        params,
        "POST"
      );
    }, // 最新讨论
    GetReportById: params => {
      return fetch(portalBasicApi + "/CustomHome/GetReportById", params);
    }, //获取报表地址
    SaveCustomHomeConfig: params => {
      return fetch(
        portalBasicApi + "/CustomHome/SaveCustomHomeConfig",
        params,
        "POST"
      );
    }, // 保存模板
    GetCustomHomeConfig: () => {
      return fetch(portalBasicApi + "/CustomHome/GetCustomHomeConfig");
    }, //获取模板
    GetMonitorKpiReportList: () => {
      return fetch(portalBasicApi + "/CustomHome/GetMonitorKpiReportList");
    } // 获取被监控kpi列表
  },
  ProductReportPush: {
    GetClientPushList: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportPush/GetClientPushList",
        params
      );
    },
    AddOrModifyPush: params => {
      return fetch(
        portalBasicApi + "/Product/ProductReportPush/AddOrModifyPush",
        params,
        "POST"
      );
    },
    DeletePushById: id => {
      return fetch(
        portalBasicApi + "/Product/ProductReportPush/DeletePushById/" + id,
        {},
        "GET"
      );
    },
    GetPushItemById: id => {
      return fetch(
        portalBasicApi + "/Product/ProductReportPush/GetPushItemById/" + id
      );
    },
    GetSendFileTypeList: () => {
      return fetch(
        portalBasicApi + "/Product/ProductReportPush/GetSendFileTypeList"
      );
    }
  },
  UserSearch: {
    Search: param => {
      return fetch(
        `${portalBasicApi}/UserSearch/Search?key=${param.key}&roleid=${param.roleId}&deptid=${param.deptId}&pageindex=${param.pageIndex || 1}&pagesize=${param.pagesize || 10}&uid=${param.uid}&isProductUser=${param.isProductUser || false}`
      );
    },
    AllRole: key => {
      return fetch(
        portalBasicApi + "/UserSearch/AllRole" + (key ? "?key=" + key : "")
      );
    }
  },
  Extension: {
    CheckNetWorkConnect: () => {
      return fetch(portalBasicApi + "/Extension/CheckNetWorkConnect");
    }, // 判断是否离线
    InstalledListId: () => {
      return fetch(portalBasicApi + "/Extension/InstalledListId");
    }, // 获取已安装插件列表id, 无分页
    InstalledList: params => {
      return fetch(portalBasicApi + "/Extension/InstalledList", params);
    }, //获取已安装插件列表，分页
    UploadInstall: params => {
      return fetch(
        portalBasicApi + "/Extension/UploadInstall",
        params,
        "POST",
        true
      );
    }, // 离线上传安装
    Get: params => {
      return fetch(portalBasicApi + "/Extension/Get", params);
    }, // 获取插件详情
    Install: params => {
      return fetch(portalBasicApi + "/Extension/Install", params);
    }, // 安装插件
    UnInstall: params => {
      return fetch(portalBasicApi + "/Extension/UnInstall", params);
    }, // 卸载插件
    UploadBIInstall: params => {
      return fetch(
        portalBasicApi + "/Extension/UploadBIInstall",
        params,
        "POST",
        true
      );
    } //上传原生BI安装包
  },
  BIDataService: {
    GetKPIData: params => {
      return fetch(
        portalBasicApi + "/BIServices/BIDataService/GetKPIData",
        params
      );
    } // 获取kpi数据
  },
  FeedBack: {
    createMyItem: params => {
      return fetch(portalBasicApi + "/FeedBack/CreateItem", params, "POST");
    }
  },
  SuperSet: {
    GetDesign: () => {
      return fetch(portalBasicApi + "/SuperSet/GetDesign");
    }
  },
  PublishSuperReport: {
    GetItems: (params) => {
      return fetch(portalBasicApi + "/PublishSuperReport/GetItems", params, "POST");
    },
    DeleteItemById: (id) => {
      return fetch(portalBasicApi + "/PublishSuperReport/DeleteItemById/" + id);
    },
    SuperSetPublishGroup: (params) => {
      return fetch(portalBasicApi + "/PublishSuperReport/SuperSetPublishGroup", params, "POST");
    }
  },
  SiteConfig: {
    GetGroupTree: () => {
      return fetch(portalBasicApi + "/SiteConfig/GetGroupTree");
    }
  },
  PermissionAssignment: {
    GetRoles: () => {
      return fetch(portalBasicApi + "/PermissionAssignment/GetRoles");
    }
  },
  EarthLog: {
    Log: (params) => {
      return fetch(earthLogApi + "/AcctivityLog/LogAsync", params, "POST");
    }
  },
  AI: {
    GenerateUrl: (id) => fetch(portalBasicApi + `/AI/GenerateUrl?id=${id}`, {}, 'GET')
  },
  QuickBI: {
    GetQuickBIEmbedConfig: (userId) => fetch(portalBiApi + `/QuickBIUser/GetQuickBIEmbedConfig/${userId}`, {}, 'GET'),
    GetXiaoQQueryEmbedUrl: (userId) => fetch(portalBiApi + `/QuickBICopilot/GetXiaoQQueryEmbedUrl/${userId}`, {}, 'GET')
  },
  PowerBI: {
    ExportPowerBI: (params) =>
      fetch(
        portalBiApi + `/PowerBI/Export/${params.reportId}/${params.reportName}/${params.productId}/${params.pageName}/${params.exportType}`,
        {
          filter: params.filter || '',
          bookmarkState: params.bookmarkState || ''
        },
        'POST',
        false,
        true
      )
  }

};
